import { render, staticRenderFns } from "./notificaciones.vue?vue&type=template&id=18ce2d79&"
import script from "./notificaciones.vue?vue&type=script&lang=js&"
export * from "./notificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports